module.exports = __webpack_public_path__ + "assets/img/house-2.fb3b18d0.png";